import * as React from 'react';
import { Doughnut } from 'react-chartjs-2';
import '../../../../styles/AdminDashboardPage.css';

interface ToursPieProps {
    heading: string;
    title1Key: string;
    title2Key: string;
    title1Value: string;
    title2Value: string;
    value1: number;
    value2: number;
  }

export const ToursPie = ({ heading, title1Key, title2Key, title1Value, title2Value, value1, value2 }: ToursPieProps) => {

    const [labelFontSize, setLabelFontSize] = React.useState<number>(16); // Default font size

    React.useEffect(() => {
        // Update font size based on screen size
        const handleResize = () => {
            const width = window.innerWidth;
            if (width < 768) {
                setLabelFontSize(14); // Adjust font size for small screens
            } else if (width < 992) {
                setLabelFontSize(16); // Adjust font size for medium screens
            } else {
                setLabelFontSize(18); // Adjust font size for large screens
            }
        };

        // Call handleResize initially and add event listener
        handleResize();
        window.addEventListener('resize', handleResize);

        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', handleResize);
    }, []);
  
  return <div className='bordered-card-layout'>
        <p className='dashboard-heading'>{heading}</p>
        <Doughnut
            data={{
                labels: [
                    `${title1Key}: ${value1}%`,
                    `${title2Key}: ${value2}%`
                ],
                datasets: [
                    {
                        data: [value1,value2],
                        backgroundColor: ['#27bbf9', '#d3f1ff']
                    }
                ]
            }}
            options={{
                responsive: false,
                legend: {
                    position: 'right',
                    labels: {
                        boxWidth: 10,
                        padding: 25,
                        fontSize: labelFontSize
                    }
                },
                cutoutPercentage: 50,
                tooltips: {
                    callbacks: {
                        label: function(tooltipItem: any, data: any) {
                            const labelIndex = tooltipItem.index;
                            if (labelIndex === 0) {
                                return parseFloat(title1Value).toLocaleString('en-US');
                            } else if (labelIndex === 1) {
                                return parseFloat(title2Value).toLocaleString('en-US');
                            }
                            return '';
                        }
                    }
                }
            }}
        />
     </div>
}


// WEBPACK FOOTER //
// ./src/components/pages/admin/analyticsDashboardWidgets/toursPie.tsx